export default __webpack_public_path__ + "images/sample-logo_2hXI-.svg";